class PoliciesModal extends ModalDialog {
    constructor(){
        super();
        this.bindEvents();
    }

    bindEvents() {
        // Listen for buttons with data-target attribute
        document.addEventListener('click', (event) => {

            const button = event.target.closest('[data-target]');
            if (button) {
                const target = button.getAttribute('data-target');
                this.showContent(target);
            }
        });

        // Close modal when clicking overlay
        const overlay = this.querySelector('.modal-overlay');
        if (overlay) {
            overlay.addEventListener('click', () => {
                this.hide();
            });
        }
    }

    showContent(target) {
        // Hide all content divs
        const allContent = this.querySelectorAll('[data-content]');
        allContent.forEach(content => {
            content.hidden = true;
        });

        // Show the target content
        const targetContent = this.querySelector(`[data-content="${target}"]`);
        if (targetContent) {
            targetContent.hidden = false;
        }
    }
}

customElements.define('policies-modal', PoliciesModal);

